<template>
  <div class="size-adjust mx-auto max-w-[60ch] space-y-8 text-base">
    <p class="text-xl text-opacity-50">
      {{ t('heading') }}
    </p>
    <div class="actions flex flex-row justify-center space-x-4">
      <template v-if="isAuthenticated">
        <button
          class="action btn-primary btn relative flex w-max px-3 py-2"
          @click="signOut()"
        >
          {{ t('Sign-out') }}
        </button>
      </template>
      <template v-else>
        <button
          class="action btn-primary btn relative flex w-max px-3 py-2"
          @click="signIn()"
        >
          {{ t('Sign-in') }}
        </button>
      </template>
      <button
        v-if="!canAccessDailyWord"
        class="action btn-secondary btn relative flex w-max px-3 py-2"
        @click="subscribe()"
      >
        {{ t('Subscribe') }}
      </button>
    </div>
    <p class="font-light text-opacity-50">
      {{ t('body') }}
    </p>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "heading": "Today’s full Daily Word message is available to Daily Word digital subscribers. Please sign in or subscribe to view.",
    "body": "Daily Word magazine published by Unity since 1924, offers inspiration and practical teachings through daily affirmative messages to help people of all faiths live healthy, prosperous, and meaningful lives."
  },
  "es": {
    "heading": "El mensaje completo de La Palabra Diaria de hoy está disponible para los suscriptores digitales de La Palabra Diaria. Por favor, inicia sesión o suscríbete para verlo.",
    "body": "La revista La Palabra Diaria, publicada por Unity desde 1955, ofrece a sus lectores inspiración y enseñanzas prácticas a través de mensajes afirmativos diarios para ayudarles a llevar una vida sana, próspera y significativa."
  }
}
</i18n>

<script lang="ts" setup>
const { t } = useI18n()
const {
  data: session,
  isAuthenticated,
  canAccessDailyWord,
  signIn,
  signOut,
  subscribe,
} = useLoginLinks()
</script>
